<template>
    <div>
        <table class="table table-striped table-responsive-sm">
            <thead>
            <tr>
                <th>Create date</th>
                <th>Trip code</th>
                <th>Status</th>
                <th>Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="trip of trips" v-bind:key="trip.tripCode">
                <td>{{formatDatetime(trip.createDate)}}</td>
                <td>{{trip.tripCode}}</td>
                <td>{{formatTripStatus(trip.status)}}</td>
                <td>
                    <a href="#"
                       @click.prevent="$router.push({path: `/trips/${trip.tripCode}`})">Open</a>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>

    import {formatDatetime, formatTripStatus} from '../../utils/formatters';

    export default {
        name: "trip_table",
        props: {
            trips: Array,
        },
        methods: {
            formatDatetime,
            formatTripStatus
        }
    }
</script>

<style scoped>

</style>
